/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsonlybusiness2Inputs */

const en_groupsonlybusiness2 = /** @type {(inputs: Groupsonlybusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you write`)
};

const de_groupsonlybusiness2 = /** @type {(inputs: Groupsonlybusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur du schreibst`)
};

/**
* | output |
* | --- |
* | "Only you write" |
*
* @param {Groupsonlybusiness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsonlybusiness2 = /** @type {((inputs?: Groupsonlybusiness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsonlybusiness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsonlybusiness2(inputs)
	return de_groupsonlybusiness2(inputs)
});
export { groupsonlybusiness2 as "groupsOnlyBusiness" }